import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  setOperationStatus,
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
} from '@uncinc/react-drupal-core';

import useOperationStatus from '../../../hooks/useOperationStatus';
import useClasses from '../../../hooks/useClasses';
import useToast from '../../../hooks/useToast';
import useTypedDispatch from '../../../hooks/useTypedDispatch';
import { sendValidationEmail } from '../../../store/actions/User';

const CrisisBannerValidateEmail: React.FC = () => {
  const dispatch = useTypedDispatch();
  const { t } = useTranslation();
  const toast = useToast();
  const operationStatus = useOperationStatus('user', 'send_validation_email');

  const { buildClass } = useClasses('CrisisBanner');

  React.useEffect(() => {
    if (operationStatus === UI_OPERATION_STATUS_SUCCESS) {
      toast.show(t('pages.send_validate_email.toast_success'), 'success');
    }

    if (operationStatus === UI_OPERATION_STATUS_ERROR) {
      toast.show(t('pages.send_validate_email.toast_error'), 'error');
    }

    if (operationStatus !== UI_OPERATION_STATUS_REQUEST) {
      // Consume the operation status so the toast won't show again.
      dispatch(setOperationStatus('user', 'send_validation_email', null));
    }
  }, [operationStatus, toast, t, dispatch]);

  return (
    <div className={buildClass()}>
      <p>
        <Trans i18nKey="pages.send_validate_email.crisis_banner">
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <button
            type="button"
            className="textual-link p-0"
            onClick={() => {
              dispatch(sendValidationEmail());
            }}
          />
        </Trans>
      </p>
    </div>
  );
};

export default CrisisBannerValidateEmail;
